const defaultOptions = {
  accountingCategoryRid: null,
  defaultUnitRid: null,
  goodsCategoryRid: null,
  groupRootRid: null,
  uploadCals: false,
  uploadMinMaxAmounts: false,
  uploadPrecent: false,
};
const defaultColumns = {
  carbs: null,
  code: null,
  fats: null,
  max: null,
  min: null,
  name: null,
  path: null,
  precentle1: null,
  precentle2: null,
  proteins: null,
  tareGrams: null,
  unitName: null,
};

export default {
  preserverState: true,
  state: {
    uploadOptions: {
      accountingCategoryRid: null,
      goodsCategoryRid: null,
      groupRootRid: null,
      defaultUnitRid: null,
      uploadCals: false,
      uploadMinMaxAmounts: false,
      uploadPrecent: false,
    },
    lineSkip: 1,
    units: null,
    columns: {
      carbs: null,
      code: null,
      fats: null,
      max: null,
      min: null,
      name: null,
      path: null,
      precentle1: null,
      precentle2: null,
      proteins: null,
      tareGrams: null,
      unitName: null,
    },
    fileData: null,
    fileColumnsCount: 0,
    uploadedJson: null,
    pathSep: "/",
    uploadGroups: null,
  },
  mutations: {
    updateOptions(state, options) {
      state.uploadOptions = Object.assign({}, options);
    },
    updateSkip(state, val) {
      state.lineSkip = val;
    },
    updatePathSep(state, val) {
      state.pathSep = val;
    },

    updateColumns(state, val) {
      state.columns = Object.assign({}, val);
    },
    updateFileData(state, { val, count }) {
      state.fileData = val;
      state.fileColumnsCount = count;
    },
    updateUnits(state, val) {
      state.units = val;
    },
    updateUnitRid(state, { idx, val }) {
      state.units[idx].rid = val;
    },
    updateUploadOption(state, { key, val }) {
      state.uploadOptions[key] = val;
    },
    updateColumn(state, { key, val }) {
      state.columns[key] = val;
    },
    updateUploaded(state, val) {
      state.uploadedJson = val;
    },
    updateUploadGroups(state, val) {
      state.uploadGroups = val;
    },
    loadSavedUnits(state, units) {
      for (const unit of units) {
        if (state.units != null) {
          const found = state.units.find((e) => e.name == unit.file_name);
          if (found) {
            found.rid = unit.sh_rid;
          }
        }
      }
    },
  },
  getters: {
    skip(state) {
      return state.lineSkip;
    },
    units(state) {
      return state.units;
    },
    uploadOptions(state) {
      return state.uploadOptions;
    },
    columns(state) {
      return state.columns;
    },
    pathSep(state) {
      return state.pathSep;
    },

    caloryOk(state) {
      return (
        !state.uploadOptions.uploadCals ||
        (state.columns.carbs != null &&
          state.columns.fats != null &&
          state.columns.proteins != null)
      );
    },
    amountsOk(state) {
      return (
        !state.uploadOptions.uploadMinMaxAmounts ||
        (state.columns.min != null && state.columns.max != null)
      );
    },
    precentlesOk(state) {
      return (
        !state.uploadOptions.uploadPrecent ||
        (state.columns.precentle1 != null && state.columns.precentle2 != null)
      );
    },
    defaultOptionsOk(state) {
      return (
        state.uploadOptions.accountingCategoryRid != null &&
        state.uploadOptions.goodsCategoryRid != null &&
        state.uploadOptions.groupRootRid != null
      );
    },
    defaultColumnsOk(state) {
      return (
        state.columns.name != null &&
        state.columns.path != null &&
        state.columns.code != null &&
        state.columns.unitName != null
      );
    },
    defaultUnitRidOk(state) {
      return state.uploadOptions
        ? state.uploadOptions.defaultUnitRid != null
        : false;
    },
    struct(state) {
      return Object.assign(
        {},
        { columns: state.columns },
        { uploadOptions: state.uploadOptions },
        {
          fileData: state.fileData ? state.fileData.slice(state.lineSkip) : [],
        },
        { units: state.units ? state.units : [] }
      );
    },
    fileData(state) {
      let items = [];
      if (state.fileData != null) {
        for (const row of state.fileData) {
          items.push({ ...row });
        }
      }
      return items;
    },
    fileColumns(state) {
      return state.fileColumnsCount;
    },
    uploaded(state) {
      return state.uploadedJson;
    },
    toUploadGroups(state) {
      return state.uploadGroups;
    },
  },
  actions: {
    clearOptions(context) {
      context.commit("updateOptions", defaultOptions);
    },
    clearColumns(context) {
      context.commit("updateColumns", defaultColumns);
    },
    updateColumns(context, val) {
      context.commit("updateColumns", val);
    },
    updateSkip(context, val) {
      context.commit("updateSkip", val);
    },
    clearUpload(context) {
      context.commit("updateUploaded", null);
    },
    async parseFile(context, { file, delimiter }) {
      let mf = new FormData();
      mf.append("file", file);
      mf.append("lineSkip", 0);
      if (delimiter != null) mf.append("delimiter", delimiter);
      try {
        let res = await fetch(
          `${context.getters.url}/api/v1/sh/prepare/structure`,
          { method: "POST", body: mf }
        );
        if (res.status == 200) {
          let json = await res.json();
          context.commit("updateColumns", json["columns"]);
          context.commit("updateOptions", json["uploadOptions"]);
          context.commit("updateFileData", {
            val: json["fileData"],
            count: json["csvColumnsCount"],
          });
        } else {
          let message = (await res.text());
          throw new Error(message);
        }
      } catch (error) {
        context.commit("updateMessage", {
          title: `Ошибка парсинга`,
          text: error.message,
          isError: true,
        });
      }
    },
    async parseUnits(context) {
      try {
        let res = await fetch(
          `${context.getters.url}/api/v1/sh/prepare/units`,
          {
            method: "POST",
            body: JSON.stringify(context.getters.struct),
            headers: { "Content-Type": "application/json" },
          }
        );
        if (res.status == 200) {
          let json = await res.json();
          context.commit("updateUnits", json["units"]);
        } else {
          let message = (await res.text());
          throw new Error(message);
        }
      } catch (error) {
        context.commit("updateMessage", {
          title: `Ошибка парсинга ед. измерения`,
          text: error.message,
          isError: true,
        });
      }
    },
    updateUnitRid(context, { idx, val }) {
      context.commit("updateUnitRid", { idx, val });
    },
    updateUploadOption(context, { key, val }) {
      context.commit("updateUploadOption", { key, val });
    },
    updateColumn(context, { key, val }) {
      context.commit("updateColumn", { key, val });
    },
    async upload(context) {
      try {
        let res = await fetch(`${context.getters.url}/api/v1/sh/upload`, {
          method: "POST",
          body: JSON.stringify(
            Object.assign(
              {},
              context.getters.selected,
              { uploadOptions: context.getters.uploadOptions },
              { group_list: context.getters.toUploadGroups },
              { path_separator: context.getters.pathSep }
            )
          ),
          headers: { "Content-Type": "application/json" },
        });
        if (res.status == 200) {
          context.commit("updateUploaded", await res.json());
          context.commit("updateMessage", {
            title: `Загрузка завершена`,
            text: `Загрузка прошла успешно`,
            isError: false,
          });
        } else {
          let message = await res.text();
          throw new Error(message);
        }
      } catch (error) {
        context.commit("updateMessage", {
          title: `Статус загрузки`,
          text: error.message,
          isError: true,
        });
      }
    },
    async prepareUpload(context) {
      try {
        let res = await fetch(
          `${context.getters.url}/api/v1/sh/prepare/upload`,
          {
            method: "POST",
            body: JSON.stringify(
              Object.assign(
                {},
                context.getters.selected,
                context.getters.struct,
                { path_separator: context.getters.pathSep }
              )
            ),
            headers: { "Content-Type": "application/json" },
          }
        );
        if (res.status == 200) {
          context.commit("updateUploadGroups", await res.json());
        } else {
          let message = await res.text();
          throw new Error(message);
        }
      } catch (error) {
        context.commit("updateMessage", {
          title: `Поиск дублей`,
          text: error.message,
          isError: true,
        });
      }
    },
    updatePathSep(context, sep) {
      context.commit("updatePathSep", sep);
    },
    async saveUnits(context) {
      let units = [];
      for (const unit of context.getters.units) {
        units.push({ sh_rid: unit.rid, file_name: unit.name });
      }
      try {
        let res = await fetch(
          `${context.getters.url}/api/v1/sh/units/file/merge`,
          {
            method: "POST",
            body: JSON.stringify(
              Object.assign({}, context.getters.selected, {
                sh_file_units: units,
              })
            ),
            headers: { "Content-Type": "application/json" },
          }
        );

        if (res.status != 200) {
          let message = (await res.text());
          throw new Error(message);
        }
      } catch (error) {
        context.commit("updateMessage", {
          title: `Сохранение ед. измерений`,
          text: error.message,
          isError: true,
        });
      }
    },
    async loadUnits(context) {
      try {
        let res = await fetch(`${context.getters.url}/api/v1/sh/units/file`, {
          method: "POST",
          body: JSON.stringify(Object.assign({}, context.getters.selected)),
          headers: { "Content-Type": "application/json" },
        });
        if (res.status == 200) {
          let units = await res.json();
          context.commit("loadSavedUnits", units);
        } else {
          let message = (await res.text());
          throw new Error(message);
        }
      } catch (error) {
        context.commit("updateMessage", {
          title: `Загрузка сохраненных ед. измерений`,
          text: error.message,
          isError: true,
        });
      }
    },
    async undoGoods(context) {
      let uploaded = Object.assign(
        {},
        { groups: context.getters.uploaded },
        context.getters.selected
      );
      try {
        let res = await fetch(`${context.getters.url}/api/v1/sh/goods/groups`, {
          method: "DELETE",
          body: JSON.stringify(uploaded),
          headers: { "Content-Type": "application/json" },
        });
        if (res.status != 200) {
          throw new Error("Не удалось откатить изменения");
        } else {
          return true;
        }
      } catch (error) {
        context.commit("updateMessage", {
          title: `Откат изменений`,
          text: `${error.message}`,
          isError: true,
        });
        return false;
      }
    },
  },
};
